export const types = {
    COXPROPORTIONALHAZARDS: 'COX-PROPORTIONAL-HAZARDS',
    DISTRIBUTEDRANDOMFOREST:'DISTRIBUTED-RANDOM-FOREST',
    ISOLATIONFOREST:'ISOLATION-FOREST',
    PRINCIPALCOMPONENTSANALYSIS:'PRINCIPAL-COMPONENTS-ANALYSIS',
    GRADIENTBOOSTINGMACHINE:'GRADIENT-BOOSTING-MACHINE',
    GENERALIZEDLOWRANK:'GENERALIZED-LOW-RANK',
    KMEANS:'KMEANS',
    DEEPLEARNING:'DEEP-LEARNING',
    AGGREGATOR:'AGGREGATOR',
    TARGETENCODER:'TARGET-ENCODER',
    NAIVEBEANS:'NAIVE-BEANS',
    GENERALIZEDLINEAR:'GENERALIZED-LINEAR',
    STACKEDENSEMBLE:'STACKED-ENSEMBLE',
    WORLD2VEC:'WORLD2VEC',
    RULEFIT:'RULE-FIT'
};